import React from 'react';
import { createRoot } from "react-dom/client"
import './assets/css/style.css'
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Home from './pages/Home';
import Contact from './pages/Contact';
import About from './pages/About';
import Error from './assets/error/Error';
import Layout from './layouts/Layout';
import Pricing from './pages/Pricing';
import Features from './pages/Features';
import FeaturesOverview from './pages/FeaturesOverview';
import CompanyLoaderPage from './pages/CompanyPageLoader';
import ElectionPulse from './pages/ElectionPulse';
import { Helmet } from 'react-helmet';


<Helmet>
  
  <meta name="description" content="ClientShot helps businesses increase customer retention, boost sales, and enhance reputation by capturing and resolving feedback across healthcare, aviation, banking, and more." />

  <meta name="keywords" content="customer feedback tool, client feedback software, customer experience platform, feedback tracking, customer complaints resolution, QR code feedback, business insights, healthcare feedback, aviation feedback, banking feedback" />

  </Helmet>

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <Error />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "contact",
        element: <Contact />
      },
      {
        path: "about",
        element: <About />
      },
      {
        path: "pricing",
        element: <Pricing />
      },
      {
        path: "features",
        element: <FeaturesOverview />
      },
      {
        path: "features/:featureSlug",
        element: <Features />
      },
      {
        path: "election-pulse",
        element: <ElectionPulse />
      },

    ],
  },
  {
    path: "/:companyId",
    element: <CompanyLoaderPage />
  },
]);


createRoot(document.getElementById("root")).render(
  <RouterProvider router={router} />
  
);
